import { jsx } from "react/jsx-runtime";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { validateTidalLicense } from "../../base/index.js";
function CalendarTodayOutlined(props) {
  return /* @__PURE__ */ jsx(
    CalendarTodayOutlinedIcon,
    {
      "data-testid": "CalendarTodayOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "CalendarTodayOutlined",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
CalendarTodayOutlined.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "CalendarTodayOutlined"
};
validateTidalLicense();
export {
  CalendarTodayOutlined
};
//# sourceMappingURL=CalendarTodayOutlined.js.map
